import React from "react";
export const AgendaTextWrapper = (props) => {
  const { status, getAgendaStyle } = props;
  return (
    <style>
      {`.agenda-text-${status} p{
             color: ${
               getAgendaStyle("RowText", status)
                 ? `${getAgendaStyle("RowText", status).color} !important;`
                 : null
             }
             font-size: ${
               getAgendaStyle("RowText", status)
                 ? `${getAgendaStyle("RowText", status).fontSize} !important;`
                 : null
             }
             font-family: ${
               getAgendaStyle("RowText", status)
                 ? `${getAgendaStyle("RowText", status).fontFamily} !important;`
                 : null
             }
             font-weight: ${
               getAgendaStyle("RowText", status)
                 ? `${getAgendaStyle("RowText", status).fontWeight} !important;`
                 : null
             }
              }
         `}
    </style>
  );
};
